import { Typography } from "@mui/material";
import styles from "./InfoCard.module.css";

type InfoCardProps = {
	icon: React.ReactNode;
	text: string;
};

export function InfoCard({ icon, text }: InfoCardProps) {
	return (
		<div className={styles.card}>
			<div>
				{icon}
				<Typography>{text}</Typography>
			</div>
		</div>
	);
}
